(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ironside-banners"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ironside-banners')) {
  customElements.define('ironside-banners', class extends HTMLElement {
    connectedCallback() {
      this.promos = [...this.querySelectorAll('[data-promo]')];
      if (!this.promos.length) return;
      // Guarda: en el editor del theme connectedCallback corre de nuevo y duplicaría select_promotion.
      if (!this.onClick) { this.onClick = (e) => { const a = e.target.closest('[data-promo]'); if (a) this.send('select_promotion', a); }; this.addEventListener('click', this.onClick); }
      this.io?.disconnect();
      if (!('IntersectionObserver' in window)) return;
      this.io = new IntersectionObserver((entries) => entries.forEach((en) => {
        if (en.isIntersecting) { this.send('view_promotion', en.target); this.io.unobserve(en.target); }
      }), { threshold: 0.5 });
      this.promos.forEach((p) => this.io.observe(p));
    }
    disconnectedCallback() { this.io?.disconnect(); }
    send(name, el) {
      const d = el.dataset, slot = this.dataset.slot + '_' + d.index, loc = this.dataset.slot;
      const payload = { promotion_id: d.promotionId, promotion_name: d.promotionName, creative_name: d.creativeName, creative_slot: slot, location_id: loc,
        items: [{ item_id: 'bn_' + String(d.promotionId).toLowerCase(), item_name: d.creativeName, promotion_id: d.promotionId, promotion_name: d.promotionName, creative_name: d.creativeName, creative_slot: slot, location_id: loc }] };
      try { (window.ironsideGtag || ((n, p) => typeof window.gtag === 'function' && window.gtag('event', n, p)))(name, payload); } catch (e) {}
      try { window.dataLayer = window.dataLayer || []; window.dataLayer.push({ ecommerce: null }); window.dataLayer.push({ event: name, ecommerce: payload }); } catch (e) {}
      try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('ironside:' + name, payload); } catch (e) {}
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ironside-blog-posts"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ironside-blog-posts')) {
  customElements.define('ironside-blog-posts', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-track]');
      const prev = this.querySelector('[data-prev]'), next = this.querySelector('[data-next]'), nav = this.querySelector('.ibp__nav');
      if (!this.track || !prev) return;
      const step = () => {
        const c = this.track.querySelector('[data-item]');
        const w = c ? c.offsetWidth + 16 : this.track.clientWidth;
        return Math.max(1, Math.floor((this.track.clientWidth + 16) / w)) * w;
      };
      const update = () => {
        const max = this.track.scrollWidth - this.track.clientWidth;
        nav.hidden = max <= 2;
        prev.disabled = this.track.scrollLeft <= 2;
        next.disabled = this.track.scrollLeft >= max - 2;
      };
      if (!this.bound) {
        this.bound = true;
        prev.addEventListener('click', () => this.track.scrollBy({ left: -step() }));
        next.addEventListener('click', () => this.track.scrollBy({ left: step() }));
        this.track.addEventListener('scroll', update, { passive: true });
        this.addEventListener('click', (e) => {
          const a = e.target.closest('[data-select]'); if (a) this.send('select_promotion', a.closest('[data-item]'));
        });
      }
      // view_promotion una vez por tarjeta, cuando queda ≥50 % visible (también al deslizar el carrusel).
      if ('IntersectionObserver' in window && !this.io) {
        this.io = new IntersectionObserver((entries) => entries.forEach((en) => {
          if (!en.isIntersecting) return;
          this.io.unobserve(en.target); this.send('view_promotion', en.target);
        }), { threshold: 0.5 });
        this.querySelectorAll('[data-item]').forEach((c) => this.io.observe(c));
      }
      if ('ResizeObserver' in window) { this.ro = new ResizeObserver(update); this.ro.observe(this.track); }
      update();
    }
    disconnectedCallback() { this.ro?.disconnect(); this.io?.disconnect(); this.io = null; }
    send(name, c) {
      const promo = { promotion_id: c.dataset.promotionId, promotion_name: this.dataset.promoName + ' · ' + c.dataset.title, creative_name: c.dataset.title,
        creative_slot: this.dataset.location + '_' + c.dataset.index, location_id: this.dataset.location };
      const payload = Object.assign({}, promo, { items: [Object.assign({ item_id: 'blog_' + c.dataset.handle, item_name: c.dataset.title }, promo)] });
      try { (window.ironsideGtag || ((n, p) => typeof window.gtag === 'function' && window.gtag('event', n, p)))(name, payload); } catch (err) {}
      try { window.dataLayer = window.dataLayer || []; window.dataLayer.push({ ecommerce: null }); window.dataLayer.push({ event: name, ecommerce: payload }); } catch (err) {}
      try { window.Shopify?.analytics?.publish?.('ironside:' + name, payload); } catch (err) {}
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ironside-category-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ironside-category-carousel')) {
    // view_promotion una sola vez por promoción y carga de página, aunque la sección se vuelva a pintar.
    const seenPromotions = new Set();

    customElements.define('ironside-category-carousel', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.icc__track');
        this.arrows = this.querySelectorAll('.icc__arrow');
        if (this.dataset.mode === 'filter' && !this.ready) {
          this.rendered = location.search;
          this.onFilterUpdate = () => { this.rendered = location.search; this.refresh(); };
          // Horizon no vuelve a pintar la grilla con «atrás/adelante»: si cambiaron los filtros, recarga.
          this.onPopState = () => {
            const keys = (q) => [...new URLSearchParams(q)].filter(([k]) => k.startsWith('filter.')).map((e) => e.join('=')).sort().join('&');
            if (keys(location.search) !== keys(this.rendered)) location.reload();
          };
          document.addEventListener('filter:update', this.onFilterUpdate);
          window.addEventListener('popstate', this.onPopState);
        }
        if (!this.track) { this.ready = true; return; }
        // Listeners en elementos propios: se agregan una sola vez aunque el editor reconecte la sección.
        if (!this.ready) {
          this.ready = true;
          this.addEventListener('click', (e) => {
            const b = e.target.closest('.icc__arrow');
            if (b && this.track) this.track.scrollBy({ left: Number(b.dataset.dir) * this.track.clientWidth * 0.8, behavior: 'smooth' });
            const a = e.target.closest('.icc__link');
            if (!a) return;
            if (this.dataset.track === 'true') this.send('select_promotion', a);
            if (a.hasAttribute('data-filter')) this.applyFilter(e, a);
          });
        }
        this.bindTrack();
      }
      bindTrack() {
        this.track = this.querySelector('.icc__track');
        this.arrows = this.querySelectorAll('.icc__arrow');
        if (!this.track) return;
        this.arrows.forEach((b) => { b.hidden = true; });
        this.track.addEventListener('scroll', () => this.updateArrows(), { passive: true });
        // Recalcula flechas al cambiar el ancho (en vez de un listener global de resize que nunca se quita).
        if (this.resizeObserver) this.resizeObserver.disconnect();
        if ('ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(() => this.updateArrows());
          this.resizeObserver.observe(this.track);
        }
        this.updateArrows();
        if (this.viewObserver) this.viewObserver.disconnect();
        if (this.dataset.track !== 'true' || !('IntersectionObserver' in window)) return;
        this.viewObserver = new IntersectionObserver((entries) => {
          entries.forEach((en) => {
            if (!en.isIntersecting) return;
            this.viewObserver.unobserve(en.target);
            const key = en.target.dataset.promoId || (this.dataset.promotionId + '|' + en.target.dataset.handle);
            if (seenPromotions.has(key)) return;
            seenPromotions.add(key);
            this.send('view_promotion', en.target);
          });
        }, { threshold: 0.6 });
        this.querySelectorAll('.icc__link').forEach((a) => this.viewObserver.observe(a));
      }
      disconnectedCallback() {
        if (this.resizeObserver) this.resizeObserver.disconnect();
        if (this.viewObserver) this.viewObserver.disconnect();
        if (this.onFilterUpdate) {
          document.removeEventListener('filter:update', this.onFilterUpdate);
          window.removeEventListener('popstate', this.onPopState);
          this.ready = false;
        }
      }
      // Aplica el filtro con Horizon (sin recargar). Sin el formulario de filtros, navega normal.
      applyFilter(e, a) {
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return;
        const form = document.querySelector('facets-form-component');
        if (!form || typeof form.updateFiltersByURL !== 'function') return;
        e.preventDefault();
        let url = new URL(a.href, location.origin);
        if (a.dataset.clear) {
          url = new URL(location.href);
          a.dataset.clear.split(',').forEach((p) => url.searchParams.delete(p));
        }
        url.searchParams.delete('page');
        this.querySelectorAll('.icc__item--current').forEach((li) => li.classList.remove('icc__item--current'));
        a.parentElement.classList.add('icc__item--current');
        this.classList.add('is-loading');
        form.updateFiltersByURL(url.pathname + url.search);
      }
      // Vuelve a pedir la sección con la URL actual (filtros aplicados) y reemplaza el contenido.
      async refresh() {
        const id = this.dataset.sectionId;
        if (!id) return;
        const url = new URL(location.href);
        url.searchParams.set('section_id', id);
        const ctrl = (this.abort && this.abort.abort(), (this.abort = new AbortController()));
        this.classList.add('is-loading');
        try {
          const html = await (await fetch(url, { signal: ctrl.signal })).text();
          const fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('ironside-category-carousel');
          const left = this.track ? this.track.scrollLeft : 0;
          if (!fresh) { this.hidden = true; return; }
          this.innerHTML = fresh.innerHTML;
          this.hidden = fresh.hasAttribute('hidden');
          this.bindTrack();
          if (this.track) {
            this.track.scrollLeft = left;
            const cur = this.track.querySelector('.icc__item--current');
            if (cur && (cur.offsetLeft < this.track.scrollLeft || cur.offsetLeft + cur.offsetWidth > this.track.scrollLeft + this.track.clientWidth)) {
              this.track.scrollTo({ left: cur.offsetLeft - 16, behavior: 'smooth' });
            }
          }
        } catch (err) {
          if (err.name !== 'AbortError') console.warn('[ironside-category-carousel]', err);
        } finally {
          this.classList.remove('is-loading');
        }
      }
      updateArrows() {
        if (!this.track || this.arrows.length < 2) return;
        const t = this.track, max = t.scrollWidth - t.clientWidth - 2;
        this.arrows.forEach((b) => { b.hidden = max <= 0; });
        this.arrows[0].disabled = t.scrollLeft <= 2;
        this.arrows[1].disabled = t.scrollLeft >= max;
      }
      send(eventName, a) {
        const promo = {
          promotion_id: a.dataset.promoId || this.dataset.promotionId,
          promotion_name: this.dataset.promotionName,
          creative_name: a.dataset.name,
          creative_slot: this.dataset.location + '_' + a.dataset.index,
          location_id: this.dataset.location
        };
        const payload = Object.assign({}, promo, {
          items: [Object.assign({ item_id: a.dataset.itemId || 'cat_' + a.dataset.handle, item_name: a.dataset.name }, promo)]
        });
        try { (window.ironsideGtag || ((n, p) => typeof window.gtag === 'function' && window.gtag('event', n, p)))(eventName, payload); } catch (e) {}
        try { window.dataLayer = window.dataLayer || []; window.dataLayer.push({ ecommerce: null }); window.dataLayer.push({ event: eventName, ecommerce: payload }); } catch (e) {}
        try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('ironside:' + eventName, payload); } catch (e) {}
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ironside-category-tiles"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ironside-category-tiles')) {
    customElements.define('ironside-category-tiles', class extends HTMLElement {
      connectedCallback() {
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        const videos = this.querySelectorAll('.ict__video');
        if (videos.length && !reduce && 'IntersectionObserver' in window) {
          this.videoObserver = new IntersectionObserver((entries) => {
            entries.forEach((en) => {
              const v = en.target;
              if (en.isIntersecting) {
                if (!v.src && v.dataset.src) {
                  const small = window.matchMedia('(max-width: 749px)').matches;
                  v.src = (small && v.dataset.srcMobile) || v.dataset.src;
                }
                const p = v.play();
                if (p && p.then) p.then(() => v.classList.add('is-playing')).catch(() => {});
              } else if (!v.paused) {
                v.pause();
              }
            });
          }, { threshold: 0.25 });
          videos.forEach((v) => this.videoObserver.observe(v));
        }

        this.setupCarousel();

        if (this.dataset.track !== 'true') return;
        // Una sola vez por elemento, aunque el editor del theme lo desconecte y reconecte.
        if (!this.onTileClick) {
          this.onTileClick = (e) => {
            const a = e.target.closest('.ict__tile');
            if (a) this.send('select_promotion', a);
          };
          this.addEventListener('click', this.onTileClick);
        }
        if ('IntersectionObserver' in window) {
          this.viewObserver = new IntersectionObserver((entries) => {
            entries.forEach((en) => {
              if (en.isIntersecting) { this.send('view_promotion', en.target); this.viewObserver.unobserve(en.target); }
            });
          }, { threshold: 0.5 });
          this.querySelectorAll('.ict__tile').forEach((a) => this.viewObserver.observe(a));
        }
      }
      disconnectedCallback() {
        if (this.videoObserver) this.videoObserver.disconnect();
        if (this.viewObserver) this.viewObserver.disconnect();
        if (this.resizeObserver) this.resizeObserver.disconnect();
      }
      // Carrusel: flechas (solo escritorio) que avanzan una "página" y se desactivan en los extremos.
      setupCarousel() {
        const track = this.querySelector('.ict__grid');
        const prev = this.querySelector('.ict__nav--prev');
        const next = this.querySelector('.ict__nav--next');
        if (!track) return;
        // En el editor del theme, al elegir un bloque se lleva a la vista dentro del carrusel.
        if (!this.onBlockSelect) {
          this.onBlockSelect = (e) => {
            const li = e.target.closest && e.target.closest('.ict__item');
            if (li && track.scrollWidth > track.clientWidth) track.scrollTo({ left: li.offsetLeft - track.offsetLeft - parseFloat(getComputedStyle(track).paddingLeft || 0) });
          };
          this.addEventListener('shopify:block:select', this.onBlockSelect);
        }
        if (!prev || !next) return;
        const update = () => {
          const overflow = track.scrollWidth - track.clientWidth > 2;
          prev.hidden = next.hidden = !overflow;
          prev.disabled = track.scrollLeft <= 2;
          next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
        };
        const page = (dir) => {
          const item = track.querySelector('.ict__item');
          const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
          const step = item ? item.offsetWidth + gap : track.clientWidth;
          const perPage = Math.max(1, Math.floor((track.clientWidth + gap) / step));
          track.scrollBy({ left: dir * perPage * step });
        };
        if (!this.carouselBound) {
          this.carouselBound = true;
          prev.addEventListener('click', () => page(-1));
          next.addEventListener('click', () => page(1));
          track.addEventListener('scroll', update, { passive: true });
        }
        if ('ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(update);
          this.resizeObserver.observe(track);
        }
        update();
      }
      send(eventName, a) {
        const promo = {
          promotion_id: a.dataset.promotionId,
          promotion_name: (this.dataset.promoName || 'Home categorías') + ' · ' + a.dataset.name,
          creative_name: a.dataset.name,
          creative_slot: this.dataset.location + '_' + a.dataset.index,
          location_id: this.dataset.location
        };
        const payload = Object.assign({}, promo, {
          items: [Object.assign({ item_id: 'cat_' + a.dataset.handle, item_name: a.dataset.name }, promo)]
        });
        try { (window.ironsideGtag || ((n, p) => typeof window.gtag === 'function' && window.gtag('event', n, p)))(eventName, payload); } catch (e) {}
        try { window.dataLayer = window.dataLayer || []; window.dataLayer.push({ ecommerce: null }); window.dataLayer.push({ event: eventName, ecommerce: payload }); } catch (e) {}
        try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('ironside:' + eventName, payload); } catch (e) {}
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ironside-flash-deals"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ironside-flash-deals')) {
  customElements.define('ironside-flash-deals', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-track]');
      this.items = [...this.querySelectorAll('[data-item]')];
      this.list = { item_list_id: this.dataset.listId, item_list_name: this.dataset.listName };
      this.initTimer();
      // Vistos / recomendados del producto se cargan una sola vez; al reconectar (editor) solo se rearma el tracking.
      if ((this.dataset.source === 'recent' || this.dataset.source === 'related') && !this.loaded) {
        this.loaded = true;
        (this.dataset.source === 'recent' ? this.loadRecent() : this.loadRelated()).catch(() => {}).finally(() => { this.items = [...this.querySelectorAll('[data-item]')]; this.initTracking(); });
      } else {
        this.initTracking();
      }
      // Guarda: en el editor del theme connectedCallback corre de nuevo; sin esto los clics (y select_item) se duplican.
      if (this.bound) return;
      this.bound = true;
      this.querySelector('[data-prev]')?.addEventListener('click', () => this.track.scrollBy({ left: -this.track.clientWidth * 0.8, behavior: 'smooth' }));
      this.querySelector('[data-next]')?.addEventListener('click', () => this.track.scrollBy({ left: this.track.clientWidth * 0.8, behavior: 'smooth' }));
      this.track.addEventListener('scroll', () => this.updateNav(), { passive: true });
      if ('ResizeObserver' in window) { this.ro = new ResizeObserver(() => this.updateNav()); this.ro.observe(this.track); }
      this.updateNav();
      this.addEventListener('click', (e) => {
        const add = e.target.closest('[data-add]');
        if (add) { e.preventDefault(); this.add(add); return; }
        const sel = e.target.closest('[data-select]');
        if (sel) this.track_('select_item', [this.item(sel.closest('[data-item]'))]);
      });
    }
    disconnectedCallback() { clearTimeout(this.t); this.io?.disconnect(); }

    // Flechas: se ocultan si todo cabe (ej. «Vistos» con 1–2 productos) y se apagan en los extremos.
    // Sin flechas ni enlace abajo, la fila inferior también se oculta (no suma espacio).
    updateNav() {
      const nav = this.querySelector('.ifd__nav'), ft = this.querySelector('.ifd__ft');
      if (!nav || !this.track) return;
      const max = this.track.scrollWidth - this.track.clientWidth;
      nav.hidden = max <= 2;
      const [prev, next] = nav.querySelectorAll('button');
      if (prev) prev.disabled = this.track.scrollLeft <= 2;
      if (next) next.disabled = this.track.scrollLeft >= max - 2;
      if (ft) ft.hidden = !ft.querySelector('.ifd__link');
    }

    // Reloj del país (setting timezone): segundos restantes hasta la próxima hora de reinicio (ciclo de 24 h)
    remaining() {
      const p = new Intl.DateTimeFormat('en-GB', { timeZone: this.dataset.timezone || 'America/Santiago', hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23' }).formatToParts(new Date());
      const g = (t) => +p.find((x) => x.type === t).value;
      const now = g('hour') * 3600 + g('minute') * 60 + g('second');
      const r = ((+this.dataset.resetHour || 0) * 3600 - now + 86400) % 86400;
      return r === 0 ? 86400 : r;
    }
    initTimer() {
      const h = this.querySelector('[data-h]'); if (!h) return;
      const m = this.querySelector('[data-m]'), s = this.querySelector('[data-s]'), z = (n) => String(n).padStart(2, '0');
      const tick = () => { const r = this.remaining() % 86400; h.textContent = z(Math.floor(r / 3600)); m.textContent = z(Math.floor((r % 3600) / 60)); s.textContent = z(r % 60); };
      // alineado al cambio de segundo del reloj (igual que el hero) para que ambos contadores avancen juntos
      const loop = () => { tick(); this.t = setTimeout(loop, 1000 - (Date.now() % 1000)); };
      loop();
    }

    item(el) {
      const list = el.dataset.listId ? { item_list_id: el.dataset.listId, item_list_name: el.dataset.listName } : this.list;
      return { item_id: el.dataset.itemId, item_variant: el.dataset.sku, item_name: el.dataset.name, item_brand: el.dataset.brand, item_category: el.dataset.category,
        price: +el.dataset.price, discount: +el.dataset.discount, index: +el.dataset.index, quantity: 1, ...list };
    }

    // La sección vacía se oculta con un <style data-ifd-hide> (ver más abajo del markup): al cargar productos se quita.
    show() {
      const id = this.id.replace(/^ifd-/, '');
      document.querySelectorAll('style[data-ifd-hide="' + id + '"]').forEach((st) => st.remove());
      document.getElementById('shopify-section-' + id)?.style.removeProperty('display');
    }

    // Recomendados del producto (ficha): pide esta misma sección renderizada con recommendations.products
    // (intent=related) y reemplaza las tarjetas de respaldo. Si Shopify no devuelve nada, queda el respaldo.
    async loadRelated() {
      const d = this.dataset;
      if (!d.productId || !d.sectionId) return;
      const url = (d.recUrl || '/recommendations/products') + '?product_id=' + d.productId + '&limit=' + Math.min(10, +d.max || 10) + '&section_id=' + encodeURIComponent(d.sectionId) + '&intent=related';
      const html = await fetch(url).then((r) => (r.ok ? r.text() : ''));
      const t = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-track]');
      if (!t || !t.querySelector('[data-item]')) return;
      this.track.innerHTML = t.innerHTML;
      this.track.scrollLeft = 0;
      this.show();
      this.updateNav?.();
    }

    // Últimos vistos: reemplaza los recomendados (dibujados por el servidor) por lo que vio el visitante.
    async loadRecent() {
      let recs = [];
      try { recs = JSON.parse(localStorage.getItem('ironside_recently_viewed_products_v1') || '[]'); } catch (e) { return; }
      if (!Array.isArray(recs)) return;
      const exId = this.dataset.excludeId || '', exHandle = this.dataset.excludeHandle || '';
      recs = recs.map((r) => (typeof r === 'string' ? { handle: r } : r)).filter((r) => r && r.handle && r.handle !== exHandle && (!exId || String(r.id || '') !== exId));
      const max = +this.dataset.max || 12;
      if (!recs.length) return;
      const root = window.Shopify?.routes?.root || '/';
      const got = await Promise.all(recs.slice(0, max).map((r) =>
        fetch(root + 'products/' + encodeURIComponent(r.handle) + '.js', { headers: { Accept: 'application/json' } })
          .then((x) => (x.ok ? x.json() : null)).then((p) => (p ? { p, r } : null)).catch(() => null)));
      const viewed = got.filter((x) => x && String(x.p.id) !== exId && x.p.available && (x.p.variants || []).some((v) => v.available));
      if (!viewed.length) return;
      const ids = new Set(viewed.map((x) => String(x.p.id)));
      const fill = this.dataset.fill === 'true'
        ? [...this.track.querySelectorAll('[data-item]')].filter((el) => !ids.has(el.dataset.productId)).slice(0, Math.max(0, max - viewed.length))
        : [];
      const recent = { item_list_id: this.dataset.listIdRecent, item_list_name: this.dataset.listNameRecent };
      const base = this.list; // recomendados de relleno: siguen con el item_list_id de la sección (RE_…), no el de vistos
      this.track.innerHTML = viewed.map((x) => this.card(x.p, x.r, recent)).join('');
      fill.forEach((el) => { el.querySelector('.ifd__badge')?.remove(); el.dataset.listId = base.item_list_id; el.dataset.listName = base.item_list_name; this.track.appendChild(el); });
      [...this.track.querySelectorAll('[data-item]')].forEach((el, i) => (el.dataset.index = i));
      this.list = recent;
      const t = this.querySelector('[data-title]'), s = this.querySelector('[data-subtitle]');
      if (t && this.dataset.titleRecent) { t.textContent = this.dataset.titleRecent; t.hidden = false; }
      if (s) { s.textContent = this.dataset.subtitleRecent || ''; s.hidden = !this.dataset.subtitleRecent; }
      this.track.scrollLeft = 0;
      this.show();
      this.updateNav?.();
    }
    money(cents) {
      const n = (+cents || 0) / 100, f = this.dataset.moneyFormat || '${{amount_no_decimals_with_comma_separator}}';
      const fmt = (d, th, dec) => { const [a, b] = n.toFixed(d).split('.'); return a.replace(/\B(?=(\d{3})+(?!\d))/g, th) + (b && +b ? dec + b : ''); };
      return f.replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => ({
        amount: fmt(2, ',', '.'), amount_no_decimals: fmt(0, ',', '.'), amount_with_comma_separator: fmt(2, '.', ','),
        amount_no_decimals_with_comma_separator: fmt(0, '.', ','), amount_with_apostrophe_separator: fmt(2, "'", '.'),
      }[k] ?? fmt(0, '.', ',')));
    }
    card(p, r, list) {
      const e = (x) => String(x ?? '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
      const v = p.variants.find((x) => x.available) || p.variants[0];
      const dc = v.compare_at_price > v.price, pct = dc ? Math.round(((v.compare_at_price - v.price) * 100) / v.compare_at_price) : 0;
      let img = '';
      if (p.featured_image) {
        const src = (String(p.featured_image).startsWith('//') ? 'https:' : '') + p.featured_image, w = (n) => src + (src.includes('?') ? '&' : '?') + 'width=' + n;
        img = `<img src="${e(w(700))}" srcset="${[300, 450, 600, 700].map((n) => e(w(n)) + ' ' + n + 'w').join(', ')}" sizes="(max-width: 749px) 74vw, 272px" loading="lazy" alt="${e(p.title)}">`;
      }
      const rating = Math.min(5, +r.looxRating || 0), reviews = +r.looxRaters || 0;
      const rv = this.dataset.reviews === 'true' && rating > 0 && reviews > 0
        ? `<div class="ifd__rv" aria-label="${rating} de 5 estrellas, ${reviews} reseñas"><span style="--r: ${rating * 20}%" aria-hidden="true">★★★★★</span><em>${rating} (${reviews})</em></div>` : '';
      const url = e(p.url || '/products/' + p.handle);
      return `<div class="ifd__p" data-item data-item-id="shopify_${e(this.dataset.country)}_${p.id}_${v.id}" data-sku="${e(v.sku)}" data-product-id="${p.id}" data-variant-id="${v.id}"
        data-name="${e(p.title)}" data-brand="${e(p.vendor)}" data-category="${e(p.type)}" data-price="${v.price / 100}" data-discount="${dc ? (v.compare_at_price - v.price) / 100 : 0}"
        data-list-id="${e(list.item_list_id)}" data-list-name="${e(list.item_list_name)}">
        <a class="ifd__img" href="${url}" data-select tabindex="-1" aria-hidden="true">${img}</a>
        <div class="ifd__b">
          ${p.type ? `<div class="ifd__cat">${e(p.type)}</div>` : ''}
          <a class="ifd__n ifd__display" href="${url}" data-select>${e(p.title)}</a>
          ${rv}
          <div class="ifd__pr">
            <div class="ifd__pp"><strong class="ifd__display">${e(this.money(v.price))}</strong>${dc ? `<b class="ifd__dc">−${pct}%</b>` : ''}</div>
            ${dc ? `<s>Antes ${e(this.money(v.compare_at_price))}</s>` : '<s class="ifd__nos" aria-hidden="true">&nbsp;</s>'}
            ${+this.dataset.cuotas > 1 ? `<p class="ifd__cuotas"><b>${+this.dataset.cuotas} cuotas sin interés</b> de&nbsp;<b>${e(this.money(Math.round(v.price / +this.dataset.cuotas)))}</b></p>` : ''}
            ${this.dataset.cta === 'add' ? (p.variants.length === 1 ? `<button type="button" class="ifd__add" data-add data-label="${e(this.dataset.addLabel)}">${e(this.dataset.addLabel)}</button>` : `<a class="ifd__add" href="${url}" data-select>${e(this.dataset.optionsLabel)}</a>`) : `<a class="ifd__add" href="${url}" data-select>${e(this.dataset.viewLabel || 'Ver producto')}</a>`}
          </div>
        </div>
      </div>`;
    }
    // Un evento por lista: en «Vistos recientemente» conviven vistos (UV_…) y recomendados de relleno (RE_…);
    // el item_list_id del evento debe ser el mismo que el de sus ítems (BigQuery / dimensiones de evento).
    track_(name, items) {
      const groups = new Map();
      items.forEach((i) => { const k = i.item_list_id || this.list.item_list_id; if (!groups.has(k)) groups.set(k, []); groups.get(k).push(i); });
      groups.forEach((group, id) => {
        const list = { item_list_id: id, item_list_name: group[0].item_list_name || this.list.item_list_name };
        const payload = { ...list, currency: this.dataset.currency, value: group.reduce((a, i) => a + i.price, 0), items: group };
        try { (window.ironsideGtag || ((n, p) => typeof window.gtag === 'function' && window.gtag('event', n, p)))(name, payload); } catch (e) {}
        try { window.dataLayer = window.dataLayer || []; window.dataLayer.push({ ecommerce: null }); window.dataLayer.push({ event: name, ecommerce: payload }); } catch (e) {}
        try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('ironside:' + name, payload); } catch (e) {}
      });
    }
    // view_item_list una vez por producto, cuando la tarjeta queda >=50% visible
    initTracking() {
      if (!this.items.length || !('IntersectionObserver' in window)) return;
      const seen = new Set(); let queue = [], timer;
      this.io = new IntersectionObserver((entries) => {
        entries.forEach((en) => { if (en.isIntersecting && !seen.has(en.target)) { seen.add(en.target); queue.push(this.item(en.target)); this.io.unobserve(en.target); } });
        clearTimeout(timer); timer = setTimeout(() => { if (queue.length) { this.track_('view_item_list', queue); queue = []; } }, 400);
      }, { threshold: 0.5 });
      this.items.forEach((i) => this.io.observe(i));
    }

    async add(btn) {
      const el = btn.closest('[data-item]'); btn.setAttribute('aria-busy', 'true');
      const drawers = [...document.querySelectorAll('cart-items-component')].map((c) => c.dataset.sectionId).filter(Boolean);
      try {
        const res = await fetch((window.Shopify?.routes?.root || '/') + 'cart/add.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: +el.dataset.variantId, quantity: 1, properties: { _origen: this.dataset.origin } }], sections: drawers.join(',') || undefined }),
        });
        const data = await res.json();
        if (!res.ok) throw new Error(data.description || data.message || 'Error');
        this.track_('add_to_cart', [this.item(el)]);
        const cart = await fetch((window.Shopify?.routes?.root || '/') + 'cart.js').then((r) => r.json());
        const ev = new Event('cart:update', { bubbles: true });
        ev.detail = { resource: cart, sourceId: this.id, data: { source: 'ironside-flash-deals', itemCount: cart.item_count, productId: el.dataset.productId, variantId: el.dataset.variantId, sections: data.sections } };
        document.dispatchEvent(ev);
        const drawer = document.querySelector('cart-drawer-component');
        if (drawer && typeof drawer.open === 'function') drawer.open(); else if (!window.Rebuy) window.location.href = (window.Shopify?.routes?.root || '/') + 'cart';
      } catch (e) {
        btn.textContent = 'Sin stock suficiente'; setTimeout(() => (btn.textContent = btn.dataset.label || 'Agregar al carro'), 2500);
      } finally { btn.removeAttribute('aria-busy'); }
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ironside-hero-carousel-cyber"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // Cuenta regresiva del hero Cyber: un solo intervalo para todos los contadores de la página.
    if (window.ihcCountdown) return;
    var pad = function (n) { return (n < 10 ? '0' : '') + n; };
    window.ihcCountdown = function () {
      document.querySelectorAll('[data-ihc-cd]').forEach(function (el) {
        var end = Date.parse(el.dataset.ihcCd);
        if (isNaN(end)) return;
        var s = Math.max(0, Math.ceil((end - Date.now()) / 1000));
        if (s === 0) {
          if (!el.dataset.done && !el.querySelector('.ihc-cd__logo, .ihc-cd__cta')) { el.hidden = true; return; }
          el.querySelector('.ihc-cd__done').textContent = el.dataset.done;
          el.classList.add('is-done');
        } else {
          el.classList.remove('is-done');
          el.querySelector('[data-u="d"]').textContent = pad(Math.floor(s / 86400));
          el.querySelector('[data-u="h"]').textContent = pad(Math.floor((s % 86400) / 3600));
          el.querySelector('[data-u="m"]').textContent = pad(Math.floor((s % 3600) / 60));
          el.querySelector('[data-u="s"]').textContent = pad(s % 60);
        }
        el.hidden = false;
        el.classList.add('is-ready');
      });
    };
    // el JS de secciones se carga en todas las páginas: el intervalo solo corre si hay contadores
    var timer;
    var start = function () {
      if (timer || !document.querySelector('[data-ihc-cd]')) return;
      // alineado al cambio de segundo del reloj (igual que Flash Deals) para que ambos contadores avancen juntos
      timer = true;
      (function loop() { window.ihcCountdown(); setTimeout(loop, 1000 - (Date.now() % 1000)); })();
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
    document.addEventListener('shopify:section:load', function () { window.ihcCountdown(); start(); });
  })();

  (function () {
    if (customElements.get('ironside-hero-carousel')) return;

    function sendPromo(eventName, el, location) {
      var promo = {
        promotion_id: el.dataset.promotionId,
        promotion_name: el.dataset.promotionName,
        creative_name: el.dataset.creativeName,
        creative_slot: el.dataset.creativeSlot,
        location_id: location
      };
      var payload = { promotion_id: promo.promotion_id, promotion_name: promo.promotion_name,
        creative_name: promo.creative_name, creative_slot: promo.creative_slot, location_id: location,
        items: [{ item_id: promo.promotion_id, item_name: promo.promotion_name, promotion_id: promo.promotion_id,
          promotion_name: promo.promotion_name, creative_name: promo.creative_name, creative_slot: promo.creative_slot, location_id: location }] };
      try { (window.ironsideGtag || ((n, p) => typeof window.gtag === 'function' && window.gtag('event', n, p)))(eventName, payload); } catch (e) {}
      try { window.dataLayer = window.dataLayer || []; window.dataLayer.push({ ecommerce: null }); window.dataLayer.push({ event: eventName, ecommerce: payload }); } catch (e) {}
      try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('ironside:' + eventName, payload); } catch (e) {}
    }

    class IronsideHeroCarousel extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-track-el]');
        this.slides = Array.from(this.querySelectorAll('.ihc__slide'));
        this.dots = Array.from(this.querySelectorAll('[data-dot]'));
        this.index = 0;
        this.interval = parseInt(this.dataset.interval, 10) || 6000;
        this.style.setProperty('--ihc-interval', this.interval + 'ms');
        this.location = this.dataset.location;
        this.seen = new Set();
        this.userPaused = false;
        var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.canAutoplay = this.dataset.autoplay === 'true' && this.slides.length > 1 && !reduce && !window.Shopify?.designMode;

        this.querySelector('[data-prev]')?.addEventListener('click', () => this.go(this.index - 1, true));
        this.querySelector('[data-next]')?.addEventListener('click', () => this.go(this.index + 1, true));
        this.dots.forEach((d) => d.addEventListener('click', () => this.go(+d.dataset.dot, true)));
        this.track.addEventListener('pointerup', () => this.play(), { passive: true });
        this.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowLeft') this.go(this.index - 1, true);
          if (e.key === 'ArrowRight') this.go(this.index + 1, true);
        });

        var st;
        this.track.addEventListener('scroll', () => {
          clearTimeout(st);
          st = setTimeout(() => { this.setActive(Math.round(this.track.scrollLeft / this.track.clientWidth)); }, 80);
        }, { passive: true });

        if (this.dataset.track === 'true') {
          this.addEventListener('click', (e) => {
            var a = e.target.closest('[data-promo-click]');
            if (a) sendPromo('select_promotion', a.closest('.ihc__slide'), this.location);
          });
        }

        this.visObs = new IntersectionObserver(([en]) => {
          this.inView = en.isIntersecting;
          if (this.inView) this.trackView();
          this.inView && !this.userPaused ? this.play() : this.stop();
        }, { threshold: 0.5 });
        this.visObs.observe(this);
        document.addEventListener('visibilitychange', () => { document.hidden ? this.stop() : (!this.userPaused && this.play()); });
        this.setActive(0);
      }
      disconnectedCallback() { this.stop(); this.io?.disconnect(); this.visObs?.disconnect(); }
      go(i, manual) {
        var n = this.slides.length;
        i = ((i % n) + n) % n;
        this.track.scrollTo({ left: i * this.track.clientWidth });
        this.setActive(i);
        if (manual && !this.userPaused) this.play();
      }
      trackView() {
        var el = this.slides[this.index];
        if (this.dataset.track !== 'true' || !this.inView || !el || this.seen.has(el)) return;
        this.seen.add(el);
        sendPromo('view_promotion', el, this.location);
      }
      setActive(i) {
        this.index = i;
        this.trackView();
        this.slides.forEach((s, k) => { s.toggleAttribute('inert', k !== i); s.setAttribute('aria-hidden', k !== i); });
        this.dots.forEach((d, k) => d.setAttribute('aria-selected', k === i));
        // reinicia la animación de progreso
        if (this.hasAttribute('data-playing')) { this.removeAttribute('data-playing'); void this.offsetWidth; this.setAttribute('data-playing', ''); }
      }
      play() {
        if (!this.canAutoplay) return;
        this.stop();
        this.setAttribute('data-playing', '');
        this.timer = setInterval(() => this.go(this.index + 1), this.interval);
      }
      stop() { clearInterval(this.timer); this.removeAttribute('data-playing'); }
    }
    customElements.define('ironside-hero-carousel', IronsideHeroCarousel);

    document.addEventListener('shopify:block:select', (e) => {
      var c = e.target.closest?.('ironside-hero-carousel');
      if (c) c.go(+e.target.dataset.index);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ironside-hero-carousel"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('ironside-hero-carousel')) return;

    function sendPromo(eventName, el, location) {
      var promo = {
        promotion_id: el.dataset.promotionId,
        promotion_name: el.dataset.promotionName,
        creative_name: el.dataset.creativeName,
        creative_slot: el.dataset.creativeSlot,
        location_id: location
      };
      var payload = { promotion_id: promo.promotion_id, promotion_name: promo.promotion_name,
        creative_name: promo.creative_name, creative_slot: promo.creative_slot, location_id: location,
        items: [{ item_id: promo.promotion_id, item_name: promo.promotion_name, promotion_id: promo.promotion_id,
          promotion_name: promo.promotion_name, creative_name: promo.creative_name, creative_slot: promo.creative_slot, location_id: location }] };
      try { if (typeof window.gtag === 'function') window.gtag('event', eventName, payload); } catch (e) {}
      try { window.dataLayer = window.dataLayer || []; window.dataLayer.push({ ecommerce: null }); window.dataLayer.push({ event: eventName, ecommerce: payload }); } catch (e) {}
      try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('ironside:' + eventName, payload); } catch (e) {}
    }

    class IronsideHeroCarousel extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-track-el]');
        this.slides = Array.from(this.querySelectorAll('.ihc__slide'));
        this.dots = Array.from(this.querySelectorAll('[data-dot]'));
        this.index = 0;
        this.interval = parseInt(this.dataset.interval, 10) || 6000;
        this.style.setProperty('--ihc-interval', this.interval + 'ms');
        this.location = this.dataset.location;
        this.seen = new Set();
        this.userPaused = false;
        var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.canAutoplay = this.dataset.autoplay === 'true' && this.slides.length > 1 && !reduce && !window.Shopify?.designMode;

        this.querySelector('[data-prev]')?.addEventListener('click', () => this.go(this.index - 1, true));
        this.querySelector('[data-next]')?.addEventListener('click', () => this.go(this.index + 1, true));
        this.dots.forEach((d) => d.addEventListener('click', () => this.go(+d.dataset.dot, true)));
        this.track.addEventListener('pointerup', () => this.play(), { passive: true });
        this.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowLeft') this.go(this.index - 1, true);
          if (e.key === 'ArrowRight') this.go(this.index + 1, true);
        });

        var st;
        this.track.addEventListener('scroll', () => {
          clearTimeout(st);
          st = setTimeout(() => { this.setActive(Math.round(this.track.scrollLeft / this.track.clientWidth)); }, 80);
        }, { passive: true });

        if (this.dataset.track === 'true') {
          this.addEventListener('click', (e) => {
            var a = e.target.closest('[data-promo-click]');
            if (a) sendPromo('select_promotion', a.closest('.ihc__slide'), this.location);
          });
        }

        this.visObs = new IntersectionObserver(([en]) => {
          this.inView = en.isIntersecting;
          if (this.inView) this.trackView();
          this.inView && !this.userPaused ? this.play() : this.stop();
        }, { threshold: 0.5 });
        this.visObs.observe(this);
        document.addEventListener('visibilitychange', () => { document.hidden ? this.stop() : (!this.userPaused && this.play()); });
        this.initVideos();
        this.setActive(0);
      }
      initVideos() {
        // El video parte DESPUÉS de que cargue la capa/logo del slide (si no, compiten por ancho de banda
        // y el texto del hero aparece tarde). Con ahorro de datos o 2G solo se muestra el poster
        // (3G no: Chrome desktop lo estima por latencia y daba falsos positivos en Wi-Fi).
        // «Reducir movimiento» ya no lo bloquea: es un loop mudo de fondo y el carrusel igual no avanza solo.
        this.videos = Array.from(this.querySelectorAll('video[data-vd]'));
        if (!this.videos.length) return;
        var mq = window.matchMedia('(max-width: 749px)');
        var c = navigator.connection || {};
        var slow = c.saveData || /2g/.test(c.effectiveType || '');
        var setPoster = () => this.videos.forEach((v) => { var p = mq.matches ? v.dataset.posterM : v.dataset.posterD; if (p) v.poster = p; });
        setPoster();
        mq.addEventListener?.('change', setPoster);
        if (slow) return;
        var pick = (json, h) => {
          try {
            var mp4 = JSON.parse(json).sources.filter((x) => x.format === 'mp4').sort((x, y) => x.height - y.height);
            var s = mp4.filter((x) => x.height <= h).pop() || mp4[0];
            return s ? s.url : '';
          } catch (e) { return ''; }
        };
        // iOS en modo de bajo consumo rechaza play() aunque esté en silencio: se reintenta con el primer toque.
        var evs = ['touchend', 'click', 'keydown'];
        var retry = () => this.videos.forEach((v) => {
          if (!v.dataset.cur || !v.paused || !v.dataset.vis) return;
          v.play().then(() => evs.forEach((e) => window.removeEventListener(e, retry, true))).catch(() => {});
        });
        var tryPlay = (v) => v.play().then(() => { v.dataset.err = ''; }).catch((e) => {
          v.dataset.err = (e && e.name) || 'error';
          if (v.dataset.err === 'NotAllowedError') asImg(v);
          evs.forEach((e) => window.addEventListener(e, retry, { capture: true, passive: true }));
        });
        // Si iOS no deja reproducir (bajo consumo), Safari igual anima un MP4 dentro de <img> (como un GIF).
        // Si el <img> no carga (otros navegadores) queda el poster.
        var asImg = (v) => {
          if (v.dataset.img || !v.dataset.cur) return;
          v.dataset.img = '1';
          var im = new Image();
          im.className = 'ihc__media ihc__img ihc__vimg';
          im.alt = ''; im.setAttribute('aria-hidden', 'true');
          im.onload = () => { if (v.paused) { v.after(im); v.dataset.img = 'ok'; } };
          im.onerror = () => { v.dataset.img = 'error'; };
          im.src = v.dataset.cur;
        };
        if (/[?&]ihc_debug/.test(location.search)) this.debug(mq, c);
        var start = (v) => {
          // móvil 480p · escritorio 720p (2G/ahorro de datos ya quedan solo con poster)
          var src = mq.matches ? pick(v.dataset.vm, 480) : pick(v.dataset.vd, 720);
          if (!src || v.dataset.cur === src) return;
          v.dataset.cur = src; v.src = src; v.muted = true; v.preload = 'auto';
          tryPlay(v);
        };
        var idle = (fn) => (window.requestIdleCallback ? requestIdleCallback(fn, { timeout: 1500 }) : setTimeout(fn, 200));
        this.videos.forEach((v) => {
          var img = v.parentElement.querySelector('.ihc__logo-full img, .ihc__logo img');
          var go = () => idle(() => start(v));
          if (!img || img.complete) go();
          else { img.addEventListener('load', go, { once: true }); img.addEventListener('error', go, { once: true }); }
        });
        mq.addEventListener?.('change', () => this.videos.forEach((v) => { if (v.dataset.cur) start(v); }));
        this.vidObs = new IntersectionObserver((es) => es.forEach((en) => {
          en.target.dataset.vis = en.isIntersecting ? '1' : '';
          if (!en.target.dataset.cur) return;
          en.isIntersecting ? tryPlay(en.target) : en.target.pause();
        }), { threshold: 0.1 });
        this.videos.forEach((v) => this.vidObs.observe(v));
        // Safari deja el video en pausa al volver con «atrás» (bfcache)
        window.addEventListener('pageshow', (e) => { if (e.persisted) this.videos.forEach((v) => { if (v.dataset.cur && v.dataset.vis) tryPlay(v); }); });
      }
      // ?ihc_debug=1 → estado del video en pantalla (para revisar un celular real).
      debug(mq, c) {
        var box = document.createElement('pre');
        box.style.cssText = 'position:fixed;left:8px;right:8px;bottom:8px;z-index:99999;margin:0;padding:8px;background:rgba(0,0,0,.85);color:#0f0;font:11px/1.35 monospace;white-space:pre-wrap;border-radius:6px;pointer-events:none';
        document.body.appendChild(box);
        var t0 = Date.now();
        var paint = () => {
          var v = this.videos[0];
          box.textContent = [
            't=' + Math.round((Date.now() - t0) / 1000) + 's  ancho=' + innerWidth + ' movil=' + mq.matches,
            'reduce=' + matchMedia('(prefers-reduced-motion: reduce)').matches + ' saveData=' + !!c.saveData + ' red=' + (c.effectiveType || '?'),
            'src=' + (v.dataset.cur ? v.dataset.cur.split('/').pop().split('?')[0] : '(sin src)'),
            'paused=' + v.paused + ' ready=' + v.readyState + ' net=' + v.networkState + ' t=' + v.currentTime.toFixed(1) + ' ' + v.videoWidth + 'x' + v.videoHeight,
            'errPlay=' + (v.dataset.err || '-') + ' errMedia=' + (v.error ? v.error.code : '-') + ' img=' + (v.dataset.img || '-') + ' vis=' + (v.dataset.vis || '-'),
            navigator.userAgent.slice(0, 140)
          ].join('\n');
        };
        paint(); setInterval(paint, 500);
      }
      disconnectedCallback() { this.stop(); this.io?.disconnect(); this.visObs?.disconnect(); this.vidObs?.disconnect(); }
      go(i, manual) {
        var n = this.slides.length;
        i = ((i % n) + n) % n;
        this.track.scrollTo({ left: i * this.track.clientWidth });
        this.setActive(i);
        if (manual && !this.userPaused) this.play();
      }
      trackView() {
        var el = this.slides[this.index];
        if (this.dataset.track !== 'true' || !this.inView || !el || this.seen.has(el)) return;
        this.seen.add(el);
        sendPromo('view_promotion', el, this.location);
      }
      setActive(i) {
        this.index = i;
        this.trackView();
        this.slides.forEach((s, k) => { s.toggleAttribute('inert', k !== i); s.setAttribute('aria-hidden', k !== i); });
        this.dots.forEach((d, k) => d.setAttribute('aria-selected', k === i));
        // reinicia la animación de progreso
        if (this.hasAttribute('data-playing')) { this.removeAttribute('data-playing'); void this.offsetWidth; this.setAttribute('data-playing', ''); }
      }
      play() {
        if (!this.canAutoplay) return;
        this.stop();
        this.setAttribute('data-playing', '');
        this.timer = setInterval(() => this.go(this.index + 1), this.interval);
      }
      stop() { clearInterval(this.timer); this.removeAttribute('data-playing'); }
    }
    customElements.define('ironside-hero-carousel', IronsideHeroCarousel);

    document.addEventListener('shopify:block:select', (e) => {
      var c = e.target.closest?.('ironside-hero-carousel');
      if (c) c.go(+e.target.dataset.index);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ironside-reels"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ironside-reels')) {
    customElements.define('ironside-reels', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-track]');
        if (!this.track) return;
        // build() una sola vez (clones + listeners). Al reconectar (editor) solo se reactivan observadores y timers.
        if (!this.built) this.build();
        this.attach();
      }
      disconnectedCallback() {
        [this.videoIO, this.sectionIO, this.ro].forEach((o) => o && o.disconnect());
        document.removeEventListener('visibilitychange', this.onVis);
        clearInterval(this.auto); clearTimeout(this.settleT); clearTimeout(this.holdT);
      }

      build() {
        this.built = true;
        this.prod = this.querySelector('[data-prod]');
        this.reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.list = { item_list_id: this.dataset.listId, item_list_name: this.dataset.listName };
        this.seen = new Set(); this.queue = []; this.inView = new Set();
        this.cur = -1; this.target = null; this.touch = false; this.hold = false;
        const originals = [...this.track.querySelectorAll(':scope > [data-card]')];
        this.n = originals.length;
        this.loop = this.n >= 3;
        this.k = 0;
        if (this.loop) {
          // Copias por lado: las necesarias para llenar media pantalla ancha (sin huecos con 3–4 videos).
          const stride = (originals[1].offsetLeft - originals[0].offsetLeft) || 200;
          const w = Math.max(this.track.clientWidth, 1600);
          this.k = Math.min(4, Math.max(1, Math.ceil(w / 2 / stride / this.n) + 1));
          const before = document.createDocumentFragment(), after = document.createDocumentFragment();
          for (let r = 0; r < this.k; r++) {
            originals.forEach((c) => {
              const a = c.cloneNode(true), b = c.cloneNode(true);
              [a, b].forEach((x) => { x.removeAttribute('data-shopify-editor-block'); x.setAttribute('aria-hidden', 'true'); x.dataset.clone = ''; });
              before.appendChild(a); after.appendChild(b);
            });
          }
          this.track.prepend(before); this.track.append(after);
        }
        this.cards = [...this.track.querySelectorAll(':scope > [data-card]')];
        this.offset = this.k * this.n;
        this.cards.forEach((c) => { const v = c.querySelector('video'); v.muted = true; v.playsInline = true; });

        this.cards.forEach((c, i) => c.addEventListener('click', (e) => {
          // Lateral o en movimiento: centra. Al centro y quieto: el <a> navega (cmd/clic medio funcionan).
          if (i !== this.cur || this.moving) { e.preventDefault(); this.go(i); return; }
          this.sendPromo('select_promotion', c);
          if (c.dataset.url) this.send('select_item', c);
        }));
        this.prod.addEventListener('click', () => {
          const c = this.cards[this.cur];
          if (c && c.dataset.url) { this.sendPromo('select_promotion', c); this.send('select_item', c); }
        });
        this.querySelector('[data-prev]').addEventListener('click', () => this.step(-1));
        this.querySelector('[data-next]').addEventListener('click', () => this.step(1));
        this.track.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') { e.preventDefault(); this.step(e.key === 'ArrowLeft' ? -1 : 1); }
        });
        const hasScrollEnd = 'onscrollend' in window;
        this.track.addEventListener('scroll', () => {
          this.moving = true;
          this.update();
          if (!hasScrollEnd) { clearTimeout(this.settleT); this.settleT = setTimeout(() => this.settled(), 160); }
        }, { passive: true });
        if (hasScrollEnd) this.track.addEventListener('scrollend', () => this.settled());
        this.track.addEventListener('touchstart', () => { this.touch = true; this.pauseAuto(); clearTimeout(this.settleT); }, { passive: true });
        this.track.addEventListener('touchend', () => {
          this.touch = false;
          if (!hasScrollEnd) { clearTimeout(this.settleT); this.settleT = setTimeout(() => this.settled(), 160); }
        }, { passive: true });
        this.addEventListener('mouseenter', () => (this.hover = true));
        this.addEventListener('mouseleave', () => (this.hover = false));
        this.addEventListener('focusin', () => (this.focus = true));
        this.addEventListener('focusout', () => (this.focus = false));
        this.addEventListener('shopify:block:select', (e) => {
          const i = this.cards.indexOf(e.target.closest('[data-card]'));
          if (i >= 0) this.go(i, true);
        });
      }

      attach() {
        this.videoIO = new IntersectionObserver((entries) => {
          entries.forEach((en) => {
            const v = en.target;
            if (en.isIntersecting) {
              this.inView.add(v);
              if (!v.poster && v.dataset.poster) v.poster = v.dataset.poster;
            } else this.inView.delete(v);
          });
          this.syncPlay();
        }, { rootMargin: '300px 0px', threshold: 0 });
        this.cards.forEach((c) => this.videoIO.observe(c.querySelector('video')));
        // GA4: impresiones solo con la sección realmente en pantalla.
        this.sectionIO = new IntersectionObserver(([en]) => {
          this.visible = en.isIntersecting;
          if (this.visible) this.queue.splice(0).forEach(([name, c]) => (name === 'view_promotion' ? this.sendPromo(name, c) : this.send(name, c)));
        }, { threshold: 0.3 });
        this.sectionIO.observe(this);
        this.onVis = () => this.syncPlay();
        document.addEventListener('visibilitychange', this.onVis);
        this.lastW = 0;
        this.ro = new ResizeObserver(() => {
          const w = this.track.clientWidth;
          if (!w || w === this.lastW) return; // la barra de URL de iOS cambia el alto, no el ancho
          this.lastW = w;
          this.measure();
          this.center(this.cur >= 0 ? this.cur : this.offset, false);
          this.setActive(this.cur >= 0 ? this.cur : this.offset);
        });
        this.ro.observe(this.track);
        // Arranque aunque ResizeObserver no entregue (pestaña en segundo plano).
        setTimeout(() => {
          if (this.cur >= 0 || !this.track.clientWidth) return;
          this.lastW = this.track.clientWidth;
          this.measure(); this.center(this.offset, false); this.setActive(this.offset);
        }, 0);
        this.startAuto();
      }

      measure() {
        const c0 = this.cards[0], c1 = this.cards[1] || c0;
        this.stride = (c1.offsetLeft - c0.offsetLeft) || c0.offsetWidth || 1;
        this.x0 = c0.offsetLeft + c0.offsetWidth / 2;
      }
      pos(i) { return this.x0 + i * this.stride - this.track.clientWidth / 2; }
      center(i, smooth) { this.track.scrollTo({ left: this.pos(i), behavior: smooth ? 'smooth' : 'auto' }); }
      go(i, instant) {
        i = Math.max(0, Math.min(this.cards.length - 1, i));
        this.target = i;
        this.center(i, !instant && !this.reduce);
        if (instant) { this.target = null; this.update(); this.settled(); }
      }
      step(d) {
        let from = this.target != null ? this.target : this.cur;
        if (!this.loop) {
          this.go(Math.max(0, Math.min(this.n - 1, from + d)));
          return;
        }
        // Clics rápidos: si el destino se sale de la zona segura, primero salta a la copia del medio.
        if (from + d < 1 || from + d > this.cards.length - 2) { this.normalize(true); from = this.cur; }
        this.go(from + d);
      }
      update() {
        if (!this.stride) this.measure();
        const mid = this.track.scrollLeft + this.track.clientWidth / 2;
        const best = Math.max(0, Math.min(this.cards.length - 1, Math.round((mid - this.x0) / this.stride)));
        if (best !== this.cur) this.setActive(best);
      }
      settled() {
        if (this.touch) return; // dedo apoyado: se normaliza al soltar
        this.target = null;
        this.normalize();
        this.moving = false;
      }
      setActive(i) {
        this.cur = i;
        const step = window.matchMedia('(max-width: 749px)').matches ? 12 : 22;
        this.cards.forEach((c, j) => {
          const d = j - i, a = Math.abs(d);
          c.classList.toggle('is-c', d === 0);
          c.style.setProperty('--ry', d === 0 ? '0deg' : (d < 0 ? '38deg' : '-38deg'));
          c.style.setProperty('--tx', d === 0 ? '0px' : (d < 0 ? -step : step) + 'px');
          c.style.setProperty('--b', a === 0 ? 1 : a === 1 ? .55 : .35);
          c.style.zIndex = d === 0 ? 20 : 10 - Math.min(a, 9);
        });
        this.syncPlay();
        this.showProduct(this.cards[i]);
      }
      // Se reproducen los visibles hasta 3 a cada lado del centro; en móvil y con movimiento reducido, solo el del centro.
      syncPlay() {
        const mob = window.matchMedia('(max-width: 749px)').matches;
        const max = this.reduce || mob ? 0 : 3;
        this.cards.forEach((c, j) => {
          const v = c.querySelector('video');
          const d = Math.abs(j - this.cur);
          const want = this.inView.has(v) && !document.hidden && this.cur >= 0 && d <= max;
          if (want) {
            const src = (mob && v.dataset.srcM) || v.dataset.src;
            if (!v.src && src) v.src = src;
            if (this.blocked) this.asImg(c, v);
            if (v.paused) {
              const p = v.play();
              if (p && p.then) p.then(() => this.unblock(), (e) => {
                if (!e || e.name !== 'NotAllowedError') return;
                this.blocked = true; this.asImg(c, v); this.waitTap();
              });
            }
          } else {
            if (!v.paused) v.pause();
            c.querySelector('.irl__vimg')?.remove();
          }
        });
      }
      // Bloqueado por iOS: el MP4 en un <img> se anima igual (mudo y en loop). Otros navegadores dan error → poster.
      asImg(c, v) {
        if (this.noImg || !v.src) return;
        let im = c.querySelector('.irl__vimg');
        if (im && im.dataset.src === v.src) return;
        if (!im) {
          im = new Image();
          im.className = 'irl__vimg'; im.alt = ''; im.setAttribute('aria-hidden', 'true');
          im.onerror = () => { this.noImg = true; this.querySelectorAll('.irl__vimg').forEach((x) => x.remove()); };
          v.after(im);
        }
        im.dataset.src = v.src; im.src = v.src;
      }
      unblock() {
        if (!this.blocked) return;
        this.blocked = false;
        this.querySelectorAll('.irl__vimg').forEach((x) => x.remove());
      }
      // iOS en modo de bajo consumo rechaza play() aunque esté en silencio: se reintenta con el primer toque.
      waitTap() {
        if (this.tapWait) return;
        this.tapWait = true;
        const evs = ['touchend', 'click', 'keydown'];
        const f = () => { evs.forEach((e) => window.removeEventListener(e, f, true)); this.tapWait = false; this.syncPlay(); };
        evs.forEach((e) => window.addEventListener(e, f, { capture: true, passive: true }));
      }
      // En una copia: salta sin animación a la posición equivalente de la copia del medio, conservando el desfase.
      // Antes intercambia los <video> de las tarjetas cercanas para que los que se ven no se reinicien.
      normalize(force) {
        if (!this.loop || this.cur < 0 || (this.touch && !force)) return;
        const lo = this.offset, hi = this.offset + this.n;
        let j = this.cur;
        while (j < lo) j += this.n;
        while (j >= hi) j -= this.n;
        if (j === this.cur) return;
        const delta = j - this.cur;
        for (let q = this.cur - 5; q <= this.cur + 5; q++) {
          const r = q + delta;
          if (q < 0 || r < 0 || q >= this.cards.length || r >= this.cards.length) continue;
          const a = this.cards[q].querySelector('video'), b = this.cards[r].querySelector('video');
          const mark = document.createComment('');
          a.replaceWith(mark); b.replaceWith(a); mark.replaceWith(b);
        }
        this.track.classList.add('is-jump');
        this.track.style.scrollSnapType = 'none';
        this.track.scrollLeft += this.pos(j) - this.pos(this.cur);
        this.setActive(j);
        void this.track.offsetWidth; // aplica sin transición antes de devolverlas
        setTimeout(() => { this.track.classList.remove('is-jump'); this.track.style.scrollSnapType = ''; }, 50);
      }
      showProduct(c) {
        const p = this.prod;
        // GA4: una impresión por reel (promoción) y por producto, solo con la sección en pantalla.
        if (c && !this.seen.has('p' + c.dataset.pos)) {
          this.seen.add('p' + c.dataset.pos);
          if (this.visible) this.sendPromo('view_promotion', c); else this.queue.push(['view_promotion', c]);
        }
        if (!c || !c.dataset.url) { p.classList.add('is-empty'); p.setAttribute('tabindex', '-1'); return; }
        p.classList.remove('is-empty'); p.removeAttribute('tabindex');
        p.href = c.dataset.url;
        const img = p.querySelector('[data-prod-img]');
        if (c.dataset.img) img.src = c.dataset.img;
        p.querySelector('[data-prod-title]').textContent = c.dataset.title;
        p.querySelector('[data-prod-price]').textContent = c.dataset.price;
        p.querySelector('[data-prod-compare]').textContent = c.dataset.compare || '';
        p.classList.add('is-swap'); setTimeout(() => p.classList.remove('is-swap'), 40);
        const key = c.dataset.itemId;
        if (key && !this.seen.has(key)) {
          this.seen.add(key);
          if (this.visible) this.send('view_item_list', c); else this.queue.push(['view_item_list', c]);
        }
      }
      pauseAuto() {
        this.hold = true; clearTimeout(this.holdT);
        this.holdT = setTimeout(() => (this.hold = false), 5000);
      }
      startAuto() {
        clearInterval(this.auto);
        const s = +this.dataset.autoplay || 0;
        if (!s || this.reduce || this.n < 2) return;
        this.auto = setInterval(() => {
          if (!this.visible || this.hover || this.focus || this.hold || this.touch || document.hidden) return;
          if (this.loop) this.step(1);
          else this.go((this.cur + 1) % this.n);
        }, s * 1000);
      }
      // Promoción (mismo patrón que ironside-category-tiles): RL{n}_{ORIGEN}_{HANDLE}, ver docs/nomenclatura-ga4-promociones.md
      sendPromo(name, c) {
        const loc = this.dataset.location;
        const promo = { promotion_id: c.dataset.promoId, promotion_name: c.dataset.promoName, creative_name: c.dataset.creative,
          creative_slot: loc + '_' + c.dataset.pos, location_id: loc };
        const payload = { ...promo };
        if (c.dataset.itemId) payload.items = [{ item_id: c.dataset.itemId, item_name: c.dataset.title, price: +c.dataset.value, index: +c.dataset.pos - 1, ...promo }];
        try { (window.ironsideGtag || ((n, p) => typeof window.gtag === 'function' && window.gtag('event', n, p)))(name, payload); } catch (e) {}
        try { window.dataLayer = window.dataLayer || []; window.dataLayer.push({ ecommerce: null }); window.dataLayer.push({ event: name, ecommerce: payload }); } catch (e) {}
        try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('ironside:' + name, payload); } catch (e) {}
      }
      send(name, c) {
        const item = { item_id: c.dataset.itemId, item_name: c.dataset.title, item_brand: c.dataset.brand, item_category: c.dataset.category,
          price: +c.dataset.value, discount: +c.dataset.discount, index: +c.dataset.pos - 1, quantity: 1, ...this.list };
        if (c.dataset.variant) item.item_variant = c.dataset.variant;
        const payload = { ...this.list, currency: this.dataset.currency, value: item.price, items: [item] };
        try { (window.ironsideGtag || ((n, p) => typeof window.gtag === 'function' && window.gtag('event', n, p)))(name, payload); } catch (e) {}
        try { window.dataLayer = window.dataLayer || []; window.dataLayer.push({ ecommerce: null }); window.dataLayer.push({ event: name, ecommerce: payload }); } catch (e) {}
        try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('ironside:' + name, payload); } catch (e) {}
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
